import { render, staticRenderFns } from "./ManagerCotations.vue?vue&type=template&id=0e0f0dfb&scoped=true"
import script from "./ManagerCotations.vue?vue&type=script&lang=ts"
export * from "./ManagerCotations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0f0dfb",
  null
  
)

export default component.exports